// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { isUpdateAvailableSelector } from '../../../../../reducers/version/versionSelector';

// Actions
import { refreshPage } from '../../../../../reducers/navigationActions';

// Components
import LinkButton from '../../../../../components/buttons/LinkButton';

// Styles
import './PwaAppVersionStatus.scss';

const mapStateToProps = createStructuredSelector({
    isUpdateAvailable: isUpdateAvailableSelector,
});

const AppVersionStatus = ({ isUpdateAvailable }) => (
    <div className="version-status">
        {isUpdateAvailable ? (
            <React.Fragment>
                <span className="indicator" />
                <LinkButton onClick={refreshPage}>Update available</LinkButton>
            </React.Fragment>
        ) : (
            <React.Fragment>
                <span className="bullet">●</span>Up to date
            </React.Fragment>
        )}
    </div>
);

AppVersionStatus.propTypes = {
    isUpdateAvailable: PropTypes.bool,
};

export default connect(mapStateToProps)(AppVersionStatus);
